<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Relatório de Placas - Caixa</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="secundario"
          class="button"
          text="Exportar Excel"
          icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
      </div>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Placas que passaram pelo caixa</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input
              type="number"
              label="Nº do Caixa"
              placeholder="Digite aqui"
              name="PK_CAIX"
              formControlName="PK_CAIX"
              width="100%"></app-input>
            <app-input
              label="Operador"
              placeholder="Digite o nome"
              name="NM_FUNC"
              formControlName="NM_FUNC"
              width="100%"></app-input>
            <app-input
              type="select"
              label="Serviço"
              placeholder="Selecione"
              name="FK_SRVC"
              formControlName="FK_SRVC"
              [selectData]="servicoOptions"
              width="100%"></app-input>
            <app-input
              type="datetime-local"
              label="Data Início"
              placeholder="Digite aqui"
              name="DT_INIC"
              formControlName="DT_INIC"
              width="100%"></app-input>
            <app-input
              type="datetime-local"
              label="Data Final"
              placeholder="Digite aqui"
              name="DT_FIM"
              formControlName="DT_FIM"
              width="100%"></app-input>
          </form>
        </div>
      </div>

      <div class="actions-container">
        <app-botao
          type="secundario"
          class="button"
          text="Exportar Excel"
          icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
        <app-botao
          type="primario"
          class="button"
          text="Gerar PDF"
          icon="assets/download.svg"
          (click)="exportarPdf()"></app-botao>
      </div>

      <app-loader [isLoading]="isLoading"></app-loader>

      <div class="table-scroll" *ngIf="!isLoading">
        <app-tabela [data]="tableData" [columns]="tableColumns"></app-tabela>
      </div>
    </div>
  </div>

  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        type="number"
        label="Nº do Caixa"
        placeholder="Digite aqui"
        name="PK_CAIX"
        formControlName="PK_CAIX"
        width="100%"></app-input>
      <app-input
        label="Operador"
        placeholder="Digite o nome"
        name="NM_FUNC"
        formControlName="NM_FUNC"
        width="100%"></app-input>
      <app-input
        type="select"
        label="Serviço"
        placeholder="Selecione"
        name="FK_SRVC"
        formControlName="FK_SRVC"
        [selectData]="servicoOptions"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Início"
        placeholder="Digite aqui"
        name="DT_INIC"
        formControlName="DT_INIC"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Final"
        placeholder="Digite aqui"
        name="DT_FIM"
        formControlName="DT_FIM"
        width="100%"></app-input>
    </form>
    <div class="actions-container mobile-actions">
      <app-botao
        type="secundario"
        class="button"
        text="Exportar Excel"
        icon="assets/exportar-excel.svg"
        (click)="exportarExcel()"></app-botao>
      <app-botao
        type="primario"
        class="button"
        text="Gerar PDF"
        icon="assets/download.svg"
        (click)="exportarPdf()"></app-botao>
    </div>
    <app-card *ngIf="!isLoading" [data]="tableData" [rows]="tableColumns" [expand]="true"></app-card>
  </div>

  <app-subtitulo *ngIf="!tableData.length && !isLoading">Nenhum registro encontrado.</app-subtitulo>

  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>

  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
